// Drawola Studio: the static welcome block that index.html paints before the
// app loads. Fork-only.
//
// The Studio removes it once its first doc listing settles (see
// DrawolaStudio.tsx). When the Studio is not on screen at all, nothing would
// ever take it over, so App.tsx removes it through the hook below.

import { useLayoutEffect } from "react";

/** Id of the static node in index.html; only the static node carries it. */
export const STATIC_WELCOME_ID = "drawola-welcome";

/** Whether the static welcome is still in the document. */
export const hasStaticWelcome = (): boolean =>
  document.getElementById(STATIC_WELCOME_ID) !== null;

/** Removes the static welcome; safe to call again after it is gone. */
export const removeStaticWelcome = (): void => {
  document.getElementById(STATIC_WELCOME_ID)?.remove();
};

/**
 * Removes the static welcome while the Studio is not mounted: the editor view,
 * a Studio flag turned off, or a switch from the Studio to the editor. While
 * the Studio is mounted it owns the handover, so nothing happens here.
 */
export const useStaticWelcomeCleanup = (studioMounted: boolean): void => {
  useLayoutEffect(() => {
    if (!studioMounted) {
      removeStaticWelcome();
    }
  }, [studioMounted]);
};
